<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{anwendungsname}}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Förderung</h4>
    </div>
  </div>
  <mat-card>
     
    <div class="row-zweispaltig">
        <div class="column-zweispaltig">
          Die Förderung des Projektes erfolgt aus Mitteln des Bundesministeriums für Ernährung und Landwirtschaft (BMEL) aufgrund eines Beschlusses des deutschen Bundestages. Die Projektträgerschaft erfolgt über die Bundesanstalt für Landwirtschaft und Ernährung (BLE) im Rahmen des Bundesprogramms Nutztierhaltung.
        </div>
        <div class="column-zweispaltig">
          <img
          src="assets/img/Logo_BMEL.png"
          alt="BMEL"
          class="img"
          height="322.62px"
          style="float: left"
        />
        </div>
      </div>
   </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon [icon]="faArrowLeft" class="mx-1 icon-arrow"></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
